import React, { useContext, useEffect } from "react";

import Header from "../header";
import Footer from "../components/footer";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { adminLinks } from "./lib/constants";
import { Alert } from "components/alert/alert";

const AdminLayout = ({ children }) => {
    const { handleAdminCheck } = useContext(ViewOnlyPermissionsContext);

    useEffect(() => {
        handleAdminCheck(true);
    }, []);

    return (
        <div>
            <Alert />
            <Header links={adminLinks} />
            <div className="container">{children}</div>
            <Footer />
        </div>
    );
};

export default AdminLayout;
